module.exports = __webpack_public_path__ + "static/media/tags-off.3e2a20a9.svg";